export interface DueDates {
    dueDate: Date;
    dueDatePY: Date;
    periodFrom: Date;
    periodTo: Date;
    periodFromPY: Date;
    periodToPY: Date;
}
